import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-refresh',
  templateUrl: './icon-refresh.component.html',
  styleUrls: ['./icon-refresh.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconRefreshComponent {}
